import { Outlet } from 'react-router-dom'
import Nav from './myNav'
import Footer from './Footer'
import { toast, ToastContainer } from 'react-toastify'
const Layout = ({ currentUser, setCurrentUser, isLevel2 }) => {
  return (
    <>
      {/* <ToastContainer /> */}
      <Nav
        currentUser={currentUser}
        setCurrentUser={setCurrentUser}
        isLevel2={isLevel2}
      />
      <Outlet />
      <Footer />
    </>
  )
}

export default Layout
